if($('.customRating').length){
    $(document).ready(function() {
        var storedData = sessionStorage.getItem('ratingData');
        if (storedData) {
            $('.customRating').append(storedData);
        } else {
            $.ajax({
                url: '/hodnoceni-obchodu/',
                type: 'GET',
                success: function(response) {
                    var content = $(response);
                    var rateAverageInner = parseFloat(content.find('.rate-average-inner .rate-average').html().trim().replace(',', '.'));
                    var rateStarWrapStar = content.find('.rate-star-wrap .stars').html();
                    var rateStarWrapStarsLabel = content.find('.rate-star-wrap .stars-label').html();
                    var percentilRating = Math.floor(100*parseFloat(rateAverageInner)/5)
                    
                    var ratingsFinal = $(content.find('.votes-wrap').html());
                    var ratingsFinalElement = $('<div>').html(ratingsFinal);
                    ratingsFinalElement.find('.vote-wrap[data-testid="gridRating"]').each(function (index, element) {
                        var $element = $(element);
                        var ratingText = $element.find('>.vote-content');
                        var ratingStar = $element.find('>.vote-header>.vote-summary>.vote-rating .stars');
                        $element.append('<div class="vote-bottom"><span class="stars" data-testid="gridStars">'+ratingStar.html()+'</span><div>'+ratingText.html()+'</div></div>')
                        
                    });
                    $('.customRating .ratingCount').html('')
                    var finalHtml = '<div class="ratingFeeds">'
                    finalHtml += '<div class="starRatings"><span class="stars">'+rateStarWrapStar+'</span></div>'
                    finalHtml += '<div class="ratingCount">'+rateStarWrapStarsLabel+'</div>'
                    finalHtml += '<div class="ratingsFeed">'+ratingsFinalElement.html()+'</div>'
                    finalHtml += '</div>'
                    $('.customRating').append(finalHtml)
                    sessionStorage.setItem('ratingData', finalHtml);
                },
                error: function(xhr, status, error) {
                    console.error("Error fetching rating data:", status, error);
                }
            });
        }
    });
}